module.exports = __webpack_public_path__ + "static/media/24.d7cedd9d.mp3";